import { useState } from 'react'
import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import Table from './Table';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
const Tab1 = ({ pageState, setPageState, handleChange }) => {
  const [taxoptions, setTaxoptions] = useState([])

  const [selectedCompany, setSelectedCompany] = useState('')

  return (
    <div>
      <div>
            <div className="px-2 py-3" style={{ background: 'white' }}>
              <div style={{ display: 'flex' }} >
                <div className="col-md-6 px-2">
                  <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                    
                    <div style={{ display: 'flex', gap: '15px' }}>
                      <div style={{ flex: 1 }}>
      
                        <Input
                        type='date'
                          id="date"
                          label="Date"
                          style={{
                            height: "30px"
                          }}
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <Input
                          id="from_currency"
                          label="From Currency"
                          style={{
                            height: "30px",
                          }}
                          />
                      </div>
                      <div style={{ flex: 1 }}>
                        <Input
                          id="to_currency"
                          label="To Currency"
                          style={{
                            height: "30px",
                          }}
                          />
                      </div>
                     
                    </div>
      
                  </div>
                </div>
      
                <div className="col-md-6 px-2">
                  <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                    
                    <div style={{ display: 'flex', gap: '15px' }}>
      
      
                      <div style={{ flex: 1 }}>
                        <Input
                          id="date"
                          label="Exchange Rate (1 INR = [?] INR)"
                          style={{
                            height: "30px"
                          }}
                        />
                      </div>
      
                      <div style={{ flex: 1 }}>


                                <label style={{height:'20.4px'}}></label>
                                     <Checkbox
                                            id="forbuying"
                                            label="For Buying"
                                        />

                      </div>
                      <div style={{ flex: 1 }}>


                                <label style={{height:'20.4px'}}></label>
                                     <Checkbox
                                            id="forselling"
                                            label="For Selling"
                                        />

                      </div>
                     
                    </div>
                  
      
      
      
                  </div>
                </div>
              </div>
              
            </div>
      
          </div>
    </div>
  )
}

export default Tab1